import { Box, Typography, Button, Paper } from "@mui/material";
import { HourglassBottom, AccessTime, Logout } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { appColors } from "../../../../constants/theme";
import { pagePaperPaddingSx } from "../../../../constants/pageStyles";
import { radius } from "../../../../constants/designTokens";

const RegistrationPendingPage = () => {
    const navigate = useNavigate();
    const status = useSelector((state) => state.auth?.user?.status);
    const statusLabelMap = {
        None: "Bilinmiyor",
        IncompleteProfile: "Profil tamamlanmadı",
        PendingReview: "Değerlendiriliyor",
        Approved: "Onaylandı",
        Rejected: "Reddedildi",
        Blocked: "Engellendi",
        UpdatePending: "Güncelleme bekleniyor",
    };
    const statusLabel = statusLabelMap[status] || status;
    const canUpdateInfo = !["Approved", "Rejected", "Blocked"].includes(status);
    const onLogout = () => {
        navigate("/logout");
    };

    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255, 255, 255, 0.7)",
                backdropFilter: "blur(1px)",
                WebkitBackdropFilter: "blur(1px)",
                zIndex: 1300,
                ...pagePaperPaddingSx,
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    width: "100%",
                    height: "600px",
                    maxWidth: "600px",
                    borderRadius: `${radius.lg * 2}px`,
                    overflow: "hidden",
                    background: "rgba(255, 255, 255, 0.95)",
                    backdropFilter: "blur(5px)",
                    WebkitBackdropFilter: "blur(5px)",

                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    ...pagePaperPaddingSx,
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "1rem",
                    maxWidth: 600,
                }}
            >
                {/* İkon */}
                <Box
                    sx={{
                        width: { xs: 70, sm: 80 },
                        height: { xs: 70, sm: 80 },
                        borderRadius: "50%",
                        backgroundColor: appColors.primary,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 1,
                        flexShrink: 0,
                    }}
                >
                    <HourglassBottom sx={{ fontSize: { xs: 35, sm: 40 }, color: appColors.white }} />
                </Box>

                {/* Başlık */}
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 700,
                        color: appColors.gray900,
                        textAlign: "center",
                        fontSize: { xs: "1.5rem", sm: "1.75rem", md: "2rem" },
                        lineHeight: 1.2,
                        px: 2,
                    }}
                >
                    Kayıt İsteğiniz Değerlendiriliyor
                </Typography>

                {statusLabel && (
                    <Typography
                        variant="subtitle1"
                        sx={{
                            color: appColors.primary,
                            fontWeight: 600,
                            fontSize: { xs: "0.95rem", sm: "1rem" },
                        }}
                    >
                        Durum: {statusLabel}
                    </Typography>
                )}

                {/* Açıklama metni */}
                <Typography
                    variant="body1"
                    sx={{
                        color: appColors.gray500,
                        textAlign: "center",
                        lineHeight: 1.6,
                        fontSize: { xs: "0.9rem", sm: "1rem" },
                        px: { xs: 2, sm: 3 },
                        maxWidth: "500px",
                    }}
                >
                    Şu anda kayıt isteğiniz değerlendiriliyor.
                    SMS ya da mail yoluyla bilgilendirileceksiniz.
                </Typography>

                {/* Değerlendirme Süresi Kutusu */}
                <Box
                    sx={{
                        backgroundColor: appColors.infoBg,
                        border: `1px solid ${appColors.info}`,
                        borderRadius: "12px",
                        p: { xs: 1.5, sm: 2 },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1.5,
                        maxWidth: "100%",
                        width: "100%",
                        mx: 0,
                        mt: 1,
                    }}
                >
                    <AccessTime sx={{ fontSize: { xs: 18, sm: 20 }, color: appColors.info, flexShrink: 0 }} />
                    <Typography
                        variant="body2"
                        sx={{
                            color: appColors.infoDark,
                            fontWeight: 500,
                            fontSize: { xs: "0.8rem", sm: "0.875rem" },
                            whiteSpace: "nowrap",
                        }}
                    >
                        Ortalama değerlendirme süresi: 24-48 saat
                    </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 2, width: "100%" }}>
                    {canUpdateInfo && (
                        <Button
                            variant="outlined"
                            onClick={() => navigate("/register/doctor/info")}
                            sx={{
                                flex: 1,
                                fontWeight: 600,
                                borderRadius: "12px",
                                borderColor: appColors.primary,
                                color: appColors.primary,
                                py: 1.5,
                                px: 3,
                                mr: 0,
                                textTransform: "none",
                                "&:hover": {
                                    borderColor: appColors.primaryDark,
                                    backgroundColor: "rgba(13, 148, 136, 0.08)",
                                },
                                transition: "all 0.2s ease",
                            }}
                        >
                            Bilgileri güncelle
                        </Button>
                    )}

                    {/* Çıkış Yap Butonu */}
                    <Button
                        variant="contained"
                        onClick={onLogout}
                        startIcon={<Logout />}
                        sx={{
                            flex: 1,
                            fontWeight: 600,
                            borderRadius: "12px",
                            backgroundColor: appColors.errorDark,

                            py: 1.5,
                            px: 3,
                            fontSize: { xs: "0.875rem", sm: "1rem" },
                            ml: 0,
                            "&:hover": {
                                backgroundColor: appColors.errorDark,

                                transform: "translateY(-1px)",
                            },
                            transition: "all 0.3s ease",
                        }}
                    >
                        Çıkış Yap
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default RegistrationPendingPage;